import styled from 'styled-components';
import { marginLeft } from '../../foundation/spacing/utils.js';

var sizeToMargin = {
  '2xl': -6,
  xl: -5,
  lg: -4,
  md: -3.5,
  sm: -2.5,
  xs: -2,
  xxs: -1.5
};
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1cau2pd-0"
})(["display:flex;align-items:center;"]);
var List = styled.ul.withConfig({
  displayName: "List",
  componentId: "sc-1cau2pd-1"
})(["display:flex;"]);
var Item = styled.li.withConfig({
  displayName: "Item",
  componentId: "sc-1cau2pd-2"
})(["&:not(:first-child){", ";}"], function (_ref) {
  var $size = _ref.$size;
  return $size && marginLeft(sizeToMargin[$size]);
});

export { Container, Item, List };
